import { useMemo, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { Typography } from '@design-system/components/typography/typography';
import { AddFromLibaryVM } from '../../view-models/addFromLibrary.viewModel';
import { UploadStep } from './uploadStep';
import { getUploadText } from './mappers';

type VideoThumbnailSelect = {
  file: File;
  dispatch: AddFromLibaryVM['dispatch'];
  thumbnailTimestamp: number;
  progress: number;
  step: AddFromLibaryVM['upload']['step'];
  uploadSizeWarning?: boolean;
};

function Upload(p: VideoThumbnailSelect) {
  const playerRef = useRef<ReactPlayer>(null);
  const [metadata, setMetadata] = useState({
    duration: 0,
  });

  const sliderChange = (_event: Event | null, newValue: number | number[]) => {
    const value = newValue as number;
    if (playerRef?.current) {
      p.dispatch('thumbnailTimestamp', newValue as number);
      playerRef.current.seekTo(value);
    }
  };

  const videoUrl = useMemo(() => URL.createObjectURL(p.file), [p.file]);

  return (
    <div className="h-full">
      <div className="flex justify-center bg-black">
        <ReactPlayer
          onDuration={(duration) => setMetadata({ duration })}
          ref={playerRef}
          playing={false}
          seconds={p.thumbnailTimestamp}
          height={300}
          url={videoUrl}
          style={{
            borderRadius: '6px',
            overflow: 'hidden',
          }}
        />
      </div>
      <div className="mt-5">
        <Typography variant="bodyLarge">{getUploadText(p.step)}</Typography>
      </div>
      <UploadStep
        step={p.step}
        sliderChange={sliderChange}
        progress={p.progress}
        dispatch={p.dispatch}
        fileName={p.file.name}
        duration={metadata.duration}
        thumbnailTimestamp={p.thumbnailTimestamp}
        uploadSizeWarning={p.uploadSizeWarning}
      />
    </div>
  );
}

export default Upload;
